// @ts-nocheck
import { ApiHandler, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { getBackOrders, GetBackOrdersApiParameter } from "@store/Framework/Services/BackOrderService";
import { BackOrderCollectionModel } from "@store/Framework/Types/ApiModels";

type HandlerType = ApiHandler<GetBackOrdersApiParameter, BackOrderCollectionModel>;

export const DispatchBeginLoadBackOrders: HandlerType = props => {
    props.dispatch({
        type: "Data/BackOrders/BeginLoadBackOrders",
        parameter: props.parameter,
    });
};

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { ...props.parameter };
};

export const RequestDataFromApi: HandlerType = async props => {
    // The API supplies the back order id, which the data view uses as its key.
    props.apiResult = await getBackOrders(props.apiParameter);
};

export const DispatchCompleteLoadBackOrders: HandlerType = props => {
    props.dispatch({
        type: "Data/BackOrders/CompleteLoadBackOrders",
        collection: props.apiResult,
        parameter: props.parameter,
    });
};

export const chain = [
    PopulateApiParameter,
    DispatchBeginLoadBackOrders,
    RequestDataFromApi,
    DispatchCompleteLoadBackOrders,
];

const loadBackOrders = createHandlerChainRunner(chain, "LoadBackOrders");
export default loadBackOrders;
